@if (title) {
  <span class="card__title">{{ title }}</span>
}
<ng-content></ng-content>
